import React from 'react';
import { Image, BrowserIconWrapper } from './styles';
import Browser  from 'assets/school-admin/icons/browser.svg'

const BrowserIcon = () => (
  <BrowserIconWrapper><Image src={Browser} /></BrowserIconWrapper>
);

export default BrowserIcon;
